import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Registro from "@/pages/Registro";
import Login from "@/pages/Login";
import VerificarCorreo from "@/pages/VerificarCorreo";
import Dashboard from "@/pages/Dashboard";
import DashboardMedico from "@/pages/DashboardMedico";
import MedicoExpedientePaciente from "@/pages/MedicoExpedientePaciente";
import HistoriaClinica from "@/pages/HistoriaClinica";
import ConsultaNueva from "@/pages/ConsultaNueva";
import ConsultaDetalle from "@/pages/ConsultaDetalle";
import Directorio from "@/pages/Directorio";
import DirectorioDetalle from "@/pages/DirectorioDetalle";
import AuthCallback from "@/pages/AuthCallback";
import SeleccionarRol from "@/pages/SeleccionarRol";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminAnaliticas from "@/pages/admin/AdminAnaliticas";
import AdminPacientes from "@/pages/admin/AdminPacientes";
import AdminMedicos from "@/pages/admin/AdminMedicos";
import AdminFirmasAcuerdo from "@/pages/admin/AdminFirmasAcuerdo";
import AdminConsultas from "@/pages/admin/AdminConsultas";
import AdminAuditoria from "@/pages/admin/AdminAuditoria";
import Poc from "@/pages/Poc";
import AvisoPrivacidad from "@/pages/legal/AvisoPrivacidad";
import TerminosCondiciones from "@/pages/legal/TerminosCondiciones";
import AcuerdoDeUso from "@/pages/legal/AcuerdoDeUso";
import AcuerdoGate from "@/components/AcuerdoGate";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/registro" element={<Registro />} />
            <Route path="/login" element={<Login />} />
            <Route path="/verificar-correo" element={<VerificarCorreo />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route
              path="/auth/rol"
              element={
                <ProtectedRoute>
                  <SeleccionarRol />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute role="paciente">
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/historia-clinica"
              element={
                <ProtectedRoute role="paciente">
                  <HistoriaClinica />
                </ProtectedRoute>
              }
            />
            <Route
              path="/consulta/nueva"
              element={
                <ProtectedRoute role="paciente">
                  <ConsultaNueva />
                </ProtectedRoute>
              }
            />
            <Route
              path="/consulta/:id"
              element={
                <ProtectedRoute role="paciente">
                  <ConsultaDetalle />
                </ProtectedRoute>
              }
            />
            <Route
              path="/directorio"
              element={<Directorio />}
            />
            <Route
              path="/directorio/:id"
              element={<DirectorioDetalle />}
            />
            <Route
              path="/medico"
              element={
                <ProtectedRoute role="medico">
                  <DashboardMedico />
                </ProtectedRoute>
              }
            />
            <Route
              path="/medico/pacientes/:patient_id"
              element={
                <ProtectedRoute role="medico">
                  <MedicoExpedientePaciente />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute role="admin">
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminAnaliticas />} />
              <Route path="pacientes" element={<AdminPacientes />} />
              <Route path="pacientes/:id" element={<AdminPacientes />} />
              <Route path="medicos" element={<AdminMedicos />} />
              <Route path="medicos/:id" element={<AdminMedicos />} />
              <Route path="firmas" element={<AdminFirmasAcuerdo />} />
              <Route path="consultas" element={<AdminConsultas />} />
              <Route path="auditoria" element={<AdminAuditoria />} />
            </Route>
            <Route path="/poc" element={<Poc />} />
            <Route path="/aviso-de-privacidad" element={<AvisoPrivacidad />} />
            <Route path="/terminos-y-condiciones" element={<TerminosCondiciones />} />
            <Route path="/acuerdo-de-uso" element={<AcuerdoDeUso />} />
          </Routes>
          <AcuerdoGate />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
